<svelte:head>

    <link rel="stylesheet" type="text/css" href="/global.css" />
    <link rel="stylesheet" type="text/css" href="/css/forms.css" />

</svelte:head>

<script>

    import { createEventDispatcher } from "svelte";
    import LocationInfo from "../../admin/locationinfo.svelte";
    import PropertyIntegrations from "../../admin/integrations.svelte";

    import {
        createProperty,
        googleSet,
        integrationDelete,
        saveProperty,
        tripadvisorSet
    } from "../../api.svelte";


    const ERROR_DISAPPEAR_AFTER = 5500;
    const SUCCESS_DISAPPEAR_AFTER = 3500;


    const dispatch = createEventDispatcher();

    export let propertyId = false;
    export let propertyData = false;

    let isLoading = false;
    let formError = false;
    let integrationsError = false;

    let currentView = 'integrations';

    let isSuccessful = false;
    let errorResetTimer = null;
    let successResetTimer = null;


    let startErrorResetTimer = () => {

        if (errorResetTimer) {

            clearTimeout(errorResetTimer);
        }

        errorResetTimer = setTimeout(() => {

            formError = false;
            integrationsError = false;

        }, ERROR_DISAPPEAR_AFTER);

    };

    let startSuccessResetTimer = () => {

        if (successResetTimer) {

            clearTimeout(successResetTimer);
        }

        successResetTimer = setTimeout(() => {

            isSuccessful = false;

        }, SUCCESS_DISAPPEAR_AFTER);

    };

    /* PropertyInfo */

    let propertyInfoHandler = (evt) => {

        const details = evt.detail['details'];

        if (details['title'] === '' || details['address'] === ''
            || details['city'] === '' || details['zip'] === '') {

            formError = 'fill_fields';
            startErrorResetTimer();

            return;

        }

        isLoading = true;

        if (!propertyId || !propertyData) {

            create(details, evt.detail['category']);
            return;

        }

        save(details, evt.detail['category']);

    };

    let create = (details, category) => {

        createProperty(category, details).then((createResult) => {

            isLoading = false;

            if (createResult['status'] !== 'success') {

                formError = createResult['reason'];
                startErrorResetTimer();

                return;

            }

            dispatch('created', {
                propertyid: createResult['propertyid']
            });

            isSuccessful = true;
            startSuccessResetTimer();

        });

    };

    let save = (details, category) => {

        saveProperty(propertyId, category, details,
            propertyData['permissions']).then((saveResult) => {

            isLoading = false;

            if (saveResult['status'] !== 'success')  {

                formError = saveResult['reason'];
                startErrorResetTimer();

                return;

            }

            dispatch('saved', {});

            isSuccessful = true;
            startSuccessResetTimer();

        });

    };

    /* PropertyIntegrations */

    let switchView = (view) => {

        currentView = view;
    };

    let viewChangedHandler = (evt) => {

        switchView(evt.detail['id']);
    };

    let integrationClickedHandler = (evt) => {

        if ((Object.keys(propertyData['integrations']).length === propertyData['maxintegrations'])
            && (!Object.keys(propertyData['integrations']).includes(evt.detail['id']))) {

            integrationsError = 'max_integrations';
            startErrorResetTimer();

            return;

        }

        switchView(evt.detail['id']);

    };

    let deleteIntegrationHandler = (evt) => {

        integrationDelete(propertyId, evt.detail['integration']).then((deleteResult) => {

            if (deleteResult['status'] !== 'success') {

                integrationsError = deleteResult['reason'];
                startErrorResetTimer();

                return;

            }

            let updatedIntegrations = {};

            for (const [integrationKey, integration] of Object.entries(propertyData['integrations'])) {

                if (integrationKey !== evt.detail['integration']) {

                    updatedIntegrations[integrationKey] = integration;
                }

            }

            propertyData['integrations'] = updatedIntegrations;

        });

    };

    let integrationSelectedHandler = (evt) => {

        const details = evt.detail['details'];

        switch (evt.detail['id']) {

            case 'tripadvisor':

                tripadvisorSelected(details);
                break;

            case 'google':

                googleSelected(details);
                break;

            case 'facebook':

                facebookSelected(details);
                break;

        }

    };

    let tripadvisorSelected = (details) => {

        tripadvisorSet(propertyId, details['name'],
            details['address'], details['url']).then((setResult) => {

            if (setResult['status'] !== 'success') {

                integrationsError = setResult['reason'];
                startErrorResetTimer();

                return;

            }

            propertyData['integrations']['tripadvisor'] = setResult['integration'];

        });

    };

    let googleSelected = (details) => {

        let location = {
            'id': details['id'],
            'placeid': details['placeid'],
            'name': details['name'],
            'address': details['address']
        };

        googleSet(propertyId, location).then((setResult) => {

            if (setResult['status'] !== 'success') {

                integrationsError = setResult['reason'];
                startErrorResetTimer();

                return;

            }

            propertyData['integrations']['google'] = setResult['integration'];

        });

    };

    // TODO: Finish testing and setFacebook
    let facebookSelected = (details) => {

        console.log('facebook selected');

    };

</script>


<div class="forms-container">

    <LocationInfo
            propertyData={propertyData}
            formError={formError}
            isLoading={isLoading}
            isSuccessful={isSuccessful}
            tight={true}
            on:saved={propertyInfoHandler} />

</div>

{#if propertyId && propertyData}

    <div class="forms-container" id="integrations-container">

        <PropertyIntegrations
                propertyId={propertyId}
                propertyData={propertyData}
                currentView={currentView}
                integrationsError={integrationsError}
                on:view={viewChangedHandler}
                on:clicked={integrationClickedHandler}
                on:deleted={deleteIntegrationHandler}
                on:selected={integrationSelectedHandler} />

    </div>

{/if}


<style>

    #integrations-container {
        margin-left: 5.55vh;
    }

</style>
